import { LanguageSwitcher } from '@saas-pages/shared/public/app-shell'
import { useRouterState } from '@tanstack/react-router'
import {
  LOCALES,
  localizedPilotPath,
  useLocale,
  useT,
  type Locale,
} from '@/shared/i18n'

const LABEL: Record<Locale, string> = {
  ru: 'RU',
  en: 'EN',
}

export function LangSwitcher() {
  const t = useT()
  const { locale, setLocale } = useLocale()
  const pathname = useRouterState({ select: (state) => state.location.pathname })

  const handleLocaleChange = (nextLocale: Locale) => {
    const target = localizedPilotPath(pathname, nextLocale)
    if (target && target !== pathname) {
      window.location.assign(`${target}${window.location.search}${window.location.hash}`)
      return
    }
    setLocale(nextLocale)
  }

  return (
    <LanguageSwitcher
      locales={LOCALES}
      locale={locale}
      onLocaleChange={handleLocaleChange}
      labels={LABEL}
      ariaLabel={t.langSwitcher.aria}
    />
  )
}
